export default {
  "content": "<path d=\"M8.25 7.8l-.925-1.975L5.35 4.9l1.975-.925L8.25 2l.925 1.975 1.975.925-1.975.925L8.25 7.8zM15 10.825l-.775-1.65-1.65-.775 1.65-.775.775-1.65.775 1.65 1.65.775-1.65.775-.775 1.65zm-11.575 2l-.775-1.65L1 10.4l1.65-.775.775-1.65.775 1.65 1.65.775-1.65.775-.775 1.65zM4.15 20.5L3 19.35l7.5-7.5 4 4.025 7.45-8.35L23 8.55l-8.5 9.575-4-3.975-6.35 6.35z\" fill=\"#000\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};